export default __webpack_public_path__ + "static/media/demo2.55b74f95.png";